import { api } from "./api";

const TOKEN_KEY = "vts_admin_token_v1";

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminLogin = async (email, password) => {
  const { data } = await api.post("/admin/login", { email, password });
  setAdminToken(data.access_token);
  return data;
};

export const adminMe = async () => {
  const token = getAdminToken();
  if (!token) return null;
  try {
    const { data } = await api.get("/admin/me", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch {
    clearAdminToken();
    return null;
  }
};

export const authHeader = () => {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
